import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import PublicRoute from "./routes/PublicRoute";
import PrivateRoute from "./routes/PrivateRoute";
import ForgetPassword from "./pages/forgot-password/ForgetPassword";
import ResetPassword from "./pages/reset-password/ResetPassword";
import Login from "./pages/login/Login";
import { fetchConfigData } from "./redux/config/configThunk";
import { useAppDispatch } from "./redux/hooks";
import { useEffect, useState } from "react";
import Loading from "./components/LoadingPage/Loading";
import EmrEmulator from "./pages/emrEmulator/EmrEmulator";
import UserGuideShare from "./pages/userGuideShare/UserGuideShare";
import NotFound from "./global/404page/NotFound";
import { appRoutes } from "./routes/Routes";
import PermissionCheck from "./routes/PermissionCheck";

function App() {
  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  useEffect(() => {
    const dispatchThunk = async () => {
      await dispatch(fetchConfigData()).unwrap();
      setLoading(false);
    };
    dispatchThunk();
  }, [dispatch]);
  if (loading) {
    return <Loading />;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route element={<PublicRoute />}>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgetPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Route>
          <Route path="/emr-emulator" element={<EmrEmulator />} />
          <Route path="/faqs/:id" element={<UserGuideShare />} />
          <Route path="*" element={<NotFound />} />

          <Route path="/" element={<PrivateRoute />}>
            {appRoutes.map(({ path, element, permissionConfig, isCheckRoutePermission }) => (
              <Route
                key={path}
                path={path}
                element={
                  <PermissionCheck
                    path={path}
                    permissionConfig={permissionConfig}
                    isCheckRoutePermission={isCheckRoutePermission}
                  >
                    {element}
                  </PermissionCheck>
                }
              />
            ))}
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
